import { render, staticRenderFns } from "./SubmenuPage.vue?vue&type=template&id=6cd4d6ac&scoped=true"
import script from "./SubmenuPage.vue?vue&type=script&lang=js"
export * from "./SubmenuPage.vue?vue&type=script&lang=js"
import style0 from "./SubmenuPage.vue?vue&type=style&index=0&id=6cd4d6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd4d6ac",
  null
  
)

export default component.exports